// @flow
import React, { Children, Fragment, type Node } from 'react';
import classnames from 'classnames';

import { ICONS } from 'Components/utils/icon/icons';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';
import { Title } from 'Components/frameworks/title/Title.jsx';

import { themes } from './CheckedList.themes';

export type CheckedListProps = {
  children: Node,
  className?: string,
  itemClassName?: string,
  theme?: string,
  title?: string,
};

export function CheckedList(props: CheckedListProps) {
  const { children, className, itemClassName, theme = 'default', title } = props;

  if (!Children.count(children)) return null;

  const { thTitle, thList, thListItem, thIcon, thIconColor, thIconWidth } = themes[theme];

  return (
    <Fragment>
      {title && (
        <Title className={thTitle} theme="title-sans-3">
          {title}
        </Title>
      )}
      <ul className={classnames(className, thList)}>
        {Children.map(children, (child, idx) => (
          <li className={classnames(itemClassName, thListItem)} key={idx}>
            <Icon color={thIconColor} className={thIcon} name={ICONS.CHECK} width={thIconWidth} />
            {child}
          </li>
        ))}
      </ul>
    </Fragment>
  );
}
